// extracted by mini-css-extract-plugin
export default {"defaultMethodFormWrapper":"styles_defaultMethodFormWrapper__rrkll","defaultMethodForm":"styles_defaultMethodForm__ocWmN"};